// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2VqJT","title":"ClientReferral_title__10vKn","itemText":"ClientReferral_itemText__14_eA"};